<template>
  <div id="app">
    <!-- <HomePage /> -->
    <newPage />
  </div>
</template>

<script>
import newPage from './components/newPage'

export default {
  name: 'App',
  components: {
    newPage
  }
}
</script>

<style>
#app {
    /* background: #333; */
    margin: 0;
  /* font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px; */
  
}
html,body {
  -webkit-text-size-adjust: 100%;
  text-size-adjust: 100%;
  background: rgba(0, 0, 0, 0.87);
  height: 100vh;
  overflow: hidden;
   -webkit-user-select: none; /* Chrome, Safari, Opera */
  -moz-user-select: none;    /* Firefox */
  -ms-user-select: none;      /* IE 10+ */
  user-select: none;          /* Standard syntax */
}
</style>
